/**
 * 81 il + tüm ilçeler: `src/data/turkeyProvincesDistricts.json` (turkiyeapi.dev, ~13KB).
 */
import rawProvinces from '../data/turkeyProvincesDistricts.json';

export type TurkeyProvince = {
  name: string;
  districts: string[];
};

export const TURKEY_PROVINCES: TurkeyProvince[] = rawProvinces as TurkeyProvince[];

export function getDistrictsForProvince(provinceName: string): string[] {
  const p = TURKEY_PROVINCES.find(
    x => x.name.localeCompare(provinceName.trim(), 'tr', { sensitivity: 'accent' }) === 0,
  );
  return p?.districts ?? [];
}

/** Alfabetik (tr) il adları */
export function provinceNames(): string[] {
  return TURKEY_PROVINCES.map(p => p.name);
}

/** Profildeki serbest metin ile eşleşen ili bul (yoksa boş). */
export function matchProvinceFromProfile(cityRaw: string): string {
  const t = cityRaw.trim();
  if (!t) {
    return '';
  }
  const hit = TURKEY_PROVINCES.find(
    p => p.name.localeCompare(t, 'tr', { sensitivity: 'accent' }) === 0,
  );
  return hit?.name ?? '';
}

/** Eski serbest metin profilden seçiciye senkronlar. */
export function syncLocationFromProfile(
  cityRaw: string,
  districtRaw: string,
): { city: string; district: string } {
  const city = matchProvinceFromProfile(cityRaw);
  if (!city) {
    return { city: '', district: '' };
  }
  const list = getDistrictsForProvince(city);
  const d = districtRaw.trim();
  const hit = list.find(
    x => x.localeCompare(d, 'tr', { sensitivity: 'accent' }) === 0,
  );
  return { city, district: hit ?? '' };
}
